<p>activities-page works!</p>
